import { render, staticRenderFns } from "./TemplateSelectionGalleryPanel.vue?vue&type=template&id=1e22e50c&scoped=true"
import script from "./TemplateSelectionGalleryPanel.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionGalleryPanel.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelectionGalleryPanel.vue?vue&type=style&index=0&id=1e22e50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e22e50c",
  null
  
)

export default component.exports